module.exports = function() {
  return new Worker(__webpack_public_path__ + "f7c8c116cd421b4de8c7.worker.js");
};